import React from 'react';
import Hero from '../components/Home/Hero';
import Features from '../components/Home/Features';
import QuickAccess from '../components/Home/QuickAccess';
import ImagePreloader from '../components/ImagePreloader';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] relative">
      <ImagePreloader />
      
      {/* Global Ambient Background - Persists through scroll */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[20%] left-[-10%] w-[60vw] h-[60vw] rounded-full bg-purple-900/10 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-blue-900/10 blur-[120px]" />
      </div>

      {/* Main Content */}
      <main className="relative z-10 flex flex-col">
        <Hero />
        <Features />
        <QuickAccess />
      </main>
    </div>
  );
}